export const ACCESS_TOKEN_HEADER = "x-access-token";
export const REFRESH_TOKEN_HEADER = "x-refresh-token";
export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = "accessToken";
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = "refreshToken";
export const BEARER_TOKEN_PREFIX = "Bearer ";
export const AUTHORIZATION_HEADER = "Authorization";
export const CONTENT_TYPE_HEADER = "Content-Type";
export const APPLICATION_JSON_CONTENT_TYPE = "application/json";
export const MULTIPART_FORM_DATA_CONTENT_TYPE = "multipart/form-data";
